import { render, staticRenderFns } from "./detail_cpxx.vue?vue&type=template&id=9519f220&scoped=true&"
import script from "./detail_cpxx.vue?vue&type=script&lang=js&"
export * from "./detail_cpxx.vue?vue&type=script&lang=js&"
import style0 from "./detail_cpxx.vue?vue&type=style&index=0&id=9519f220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9519f220",
  null
  
)

export default component.exports